import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Pour la navigation
import axios from "axios";
import "./LoadDicom.css";

const UploadExamen = () => {
  const [file, setFile] = useState(null);
  const [commentaire, setCommentaire] = useState("");
  const [idRadiologue, setIdRadiologue] = useState(); // Exemple de valeur
  const [isUploading, setIsUploading] = useState(false);
  const [filePath, setFilePath] = useState("");
  const navigate = useNavigate(); // Initialisation de la navigation

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      alert("Veuillez sélectionner un fichier DICOM.");
      return;
    }
    setIdRadiologue(1)
    setIsUploading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("commentaire", commentaire);
    formData.append("idRadiologue", idRadiologue);

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("Token non trouvé dans le stockage local.");
      return;
    }

    try {
      const response = await axios.post(process.env.REACT_APP_EUREKA_PACS_URL+"/api/examen", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setFilePath(response.data.filePath);
      alert("Examen enregistré avec succès !");
    } catch (error) {
      console.error("Erreur lors de l'upload", error);
      alert("Erreur lors de l'enregistrement.");
    } finally {
      setIsUploading(false);
    }
  };

  const handleRetourAccueil = () => {
    navigate("/accueil"); // Redirige vers la page d'accueil
  };

  return (
    <div className="upload-container">
      <h1 className="upload-title">Charger un examen DICOM</h1>
      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <label htmlFor="file" className="form-label">
            Sélectionner un fichier DICOM
          </label>
          <input
            type="file"
            id="file"
            name="file"
            onChange={handleFileChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="commentaire" className="form-label">
            Commentaire
          </label>
          <textarea
            id="commentaire"
            value={commentaire}
            onChange={(e) => setCommentaire(e.target.value)}
            placeholder="Ajouter un commentaire"
            className="form-textarea"
          />
        </div>
        <div className="form-group">
          <button type="submit" disabled={isUploading} className="form-button">
            {isUploading ? "Téléchargement..." : "Enregistrer"}
          </button>
        </div>
      </form>

      {filePath && (
        <div className="success-message">
          <h3>Examen enregistré avec succès !</h3>
          <p>Chemin du fichier : {filePath}</p>
        </div>
      )}

      {/* Bouton Retour à l'accueil */}
      <div className="form-group">
        <button onClick={handleRetourAccueil} className="form-button retour-button">
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
};

export default UploadExamen;
